export enum PlacementSiteId {
    prod = 582825, // gethome.pl
    stage = 582840 // web-dev-gh.rynekpierwotny.com
}
